import type { FastifyInstance, FastifyPluginOptions } from "fastify";
import { sendWhatsApp, getAllWhatsAppMessages } from "./whatsapp.controller.js";
import { paginationSchema, whatsappSchema } from "./whatsapp.schema.js";

export default async function whatsappRoutes(
  app: FastifyInstance,
  options: FastifyPluginOptions,
) {
  app.get(
    "/",
    { schema: { querystring: paginationSchema } },
    getAllWhatsAppMessages,
  );
  app.post(
    "/send",
    {
      schema: {
        body: whatsappSchema,
      },
      preHandler: [app.authenticate],
    },
    sendWhatsApp,
  );
}
